import { httpGet } from '../utils'

export default {
  getConfig (cb) {
    httpGet('/api/upload/qiniu/config', cb)
  }
}




// WEBPACK FOOTER //
// ./src/api/lxm/qiniu.js